<template>
  <div style="display: flex;justify-content: end;">
    <div class="fs-14 mt-3" style="display: flex;align-items: center;color: black;">
      รวม {{ pageCount }} หน้า
    </div>
    <v-pagination
      style="display: flex;justify-content: end;"
      class="mt-4 mb-3"
      v-if="pageCount"
      @input="$emit('clickPagination', page)"
      v-model="page"
      :length="pageCount"
      :total-visible="8"
    ></v-pagination>

    <div style="display: flex;align-items: center;color: black;" class="mt-3">ไปหน้าที่</div>
    &nbsp; &nbsp;
    <div
      style="width: 7%;display: flex;align-items: center;color: black;"
      class="form-control mt-3"
    >
      <input
        type="number"
        name="numberPage"
        class="depainput rsu"
        v-model="numberPage.page"
        @change="$emit('sortPage', numberPage.page)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      default: undefined
    },
    page: Number,
    numberPage: {
      type: Number,
      page: undefined
    }
  },
  data() {
    return {
      pageCount: 0,
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Paginations.vue